import styled from 'styled-components';

export const DashboardStyle = styled.div`
  margin: 0 auto;
  max-width: 1400px;
  padding: 20px;
`;

export const DashContents = styled.div`
  display: flex;
  flex-direction: row;

  ${(props) => props.theme.breakpoints.down('lg')} {
    flex-direction: column;
  }
`;

export const MainContents = styled.div`
  width: calc(100% - 400px);

  ${(props) => props.theme.breakpoints.down('lg')} {
    width: 100%;
  }
`;

export const SecondaryContent = styled.div`
  width: 400px;
  padding: 0 20px;

  ${(props) => props.theme.breakpoints.down('lg')} {
    width: 100%;
    padding: 0px;
  }
`;
